<template>
    <v-layout row>
        <v-flex xs12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="$router.push(`/hr/201`)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-chip @click="$router.push(`/hr/employees/${$route.params.userId}`)" outline title="View user profile">
                        <v-avatar>
                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl($route.params.userId)"></v-img>
                        </v-avatar>
                        <span class="user-profile white--text">View User Profile</span>
                    </v-chip>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>

            <!-- details -->
            <v-layout row wrap>
                <v-flex xs12 sm9>
                    <v-card class="elavation-1" >
                        <v-toolbar flat height="40">
                            <v-chip v-if="!isMobile&&folders.length">
                                <v-icon :color="selectedFolderColor">folder</v-icon>&nbsp;&nbsp;<b>{{ selectedFolderName }}</b>
                            </v-chip>
                            <span v-if="isMobile">
                                <v-menu v-if="folders.length" left v-model="menu_status" offset-y > 
                                    <template v-slot:activator="{ on }">
                                        <v-btn :color="selectedFolderColor" v-on="on">
                                            &nbsp;&nbsp;{{selectedFolderName}}&nbsp;&nbsp;
                                            <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                            <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense v-for="(item,index) in folders" :key="index" :title="`Calendar Year ${item.fiscalYear}`">
                                        <v-list-tile @click="viewFiles(item)">
                                            <v-list-tile-title small>{{item.folderName}}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn v-if="isMobile" icon title="Create folder" @click="showCreateFolder">
                                <v-icon color="#F9A825">create_new_folder</v-icon>
                            </v-btn>
                            <v-btn v-if="hasEditRights&&isActiveAccount&&folders.length" icon title="Upload file" @click="showUpload">
                                <v-icon color="primary">cloud_upload</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="headers"
                            :items="files"
                            :loading="loading_files"
                        >  
                            <template v-slot:items="props">
                                <tr>
                                    <td @click="preview(props.item)" class="clickable" title="Click to preview file" >
                                        <v-btn icon style="margin-left:-8px;">
                                            <v-icon :color="getFileTypeIcon(props.item.fileType).color">{{ getFileTypeIcon(props.item.fileType).icon }}</v-icon>
                                        </v-btn>
                                    </td>
                                    <td @click="preview(props.item)" class="clickable" title="Click to preview file">
                                        <span class="downloadable-link">{{ props.item.documentName }}</span>
                                    </td>
                                    <td @click="preview(props.item)" class="clickable" title="Click to preview file">
                                        <span class="downloadable-link">{{ props.item.label }}</span>
                                    </td>
                                    <td @click="preview(props.item)" title="Click to preview file">
                                        {{ props.item.uploadedOn | moment('MMM DD, YYYY') }}
                                    </td>
                                    <td @click="preview(props.item)" class="clickable" title="Click to preview file">
                                        <v-chip small style="margin:-5px 0px 0px -5px;">
                                            <v-avatar>
                                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.uploadedByUser.userId)"></v-img>
                                            </v-avatar>
                                            {{props.item.uploadedByUser.firstName}} {{props.item.uploadedByUser.lastName}}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-btn v-if="hasEditRights" icon small @click="showEditUpload(props.item)" title="Click to edit" class="upload-edit">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
                <v-flex v-if="!isMobile" xs12 sm3>
                     <v-card class="elavation-1">
                        <v-toolbar flat height="37">
                            <b>201 Folders</b>
                            <v-spacer></v-spacer>
                            <v-btn v-if="hasEditRights && folders.length" icon title="Create folder" @click="showCreateFolder">
                                <v-icon color="#F9A825">create_new_folder</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-progress-linear v-if="loading_folders" indeterminate height="2" style="margin-top:-1px;"></v-progress-linear>
                        <div v-if="!loading_folders" style="margin-left:10px;">
                            <div v-if="folders.length" row wrap class="menu-container">
                                <v-chip v-for="(item, index) in folders" :key="index">
                                    <v-icon :color="item.color">folder</v-icon>&nbsp;&nbsp;
                                    <span @click="viewFiles(item)" :class="isSelected(item) ? 'menu-link-selected': 'menu-link'" :title="`Click to view ${item.folderName} files`">{{ item.folderName }}</span>&nbsp;
                                    <v-btn v-if="hasEditRights" icon small @click="showEdit(item)" class="menu-edit">
                                        <v-icon small title="Edit folder">edit</v-icon>
                                    </v-btn>
                                </v-chip>
                            </div>
                            <div v-else row wrap class="text-xs-center menu-container">
                                <p style="margin-top:5px;">You don't have any 201 folders yet. <br>Start by creating one — <br>it'll be available for all users.</p>
                                <v-btn v-if="hasEditRights" flat @click="showCreateFolder">
                                    <v-icon>folder_open</v-icon>&nbsp;
                                    Create folder
                                </v-btn>
                            </div>
                        </div>
                    </v-card>
                </v-flex>
            </v-layout>

            <!-- comments and update history components -->
             <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-dialog v-model="dialogFolder" persistent width="500">
            <add-edit-folder ref="refFolderComponent" :dialogFolder.sync="dialogFolder" @send="createFolderHandler"></add-edit-folder>
        </v-dialog>
        <v-dialog v-model="dialogUpload" persistent width="650">
            <upload ref="refUploadComponent" :dialogUpload.sync="dialogUpload" @send="getUploadsByFolder"></upload>
        </v-dialog>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>
import accessPermissions from '@/helpers/access-permissions'
import awsS3Helper from '@/helpers/aws-s3'
import hr201Api from '@/api/hr201'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'

export default {  
    name: 'HR201Files',
    metaInfo: {
        title: 'HR 201 Files',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View HR 201 Files' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'add-edit-folder': () => import('@/components/201Files/AddEditFolder'),
        'upload': () => import('@/components/201Files/UploadFiles'),
        'preview': () => import('@/components/FilePreview/Preview'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },
    data () {
        return {
            awsS3Helper,
            disabled: false,
            loading_files: false,
            loading_folders: false,
            loading_download: false,
            menu_status: false,
            error: false,
            errorMessage: '',
            headers: [
                {text:'File', align: 'left',value:'fileType', width:'5%', sortable:true},
                {text:'Document Type', align: 'left',value:'documentName', width:'35%', sortable:true},
                {text:'Label', align: 'left',value:'label', width:'35%', sortable:true},
                {text:'Uploaded On', align: 'left',value:'uploadedOn', width:'10%', sortable:true},
                {text:'Uploaded By', align: 'left',value:'lastName', width:'10%', sortable:true},
                {text:'', align: 'left',value:'team', width:'5%', sortable:false},
            ],
            dialogFolder: false,
            dialogUpload: false,    
            dialogPreview: false,
            selectedFolderId: null,
            selectedFolderName: 'Select folder to view and upload files',
            selectedFolderColor: '',
            folders: [],
            files: []
        }
    },
    methods: {
        isSelected(data) {
            return data.folderId == this.selectedFolderId
        },
        async preview(data) {
            var file = {
                name: data.label,
                type: data.fileType,
                url:  '',
                downloadUrl: awsS3Helper.getEmployeeDocumentUrl(data.userId, data.fileName, AWSS3DocumentType.HR201)
            }
            if (data.fileType == 'WordDocument' || data.fileType == 'Pdf') {
                this.loading_files = true
                const paramData = {
                    fileName: data.fileName,
                    userId: this.selectedUserId
                }
                const response = await hr201Api.getPreSignedUrl(paramData)
                if (response && response.status == 200) {
                    file.url = response.data
                    this.$refs.refPreviewComponet.setParams(file)
                    this.dialogPreview = true
                    this.loading_files = false
                }
            }else{
                file.url = awsS3Helper.getEmployeeDocumentUrl(data.userId, data.fileName, AWSS3DocumentType.HR201)
                this.$refs.refPreviewComponet.setParams(file)
                this.dialogPreview = true
            }
        },
        getFileTypeIcon(fileType) {
            var data = {
                icon: '',
                color: ''
            }
            switch(fileType) {
                case 'Pdf':
                    data.icon = 'fa-regular fa-file-pdf'
                    data.color = 'red'
                    break;
                case 'WordDocument':
                    data.icon = 'fa-solid fa-file-word'
                    data.color = 'blue'
                    break;
                case 'Image':
                    data.icon = 'fa-solid fa-file-image'
                    data.color = 'green'
                    break;
            }
            return data
        },
        showEdit(data) {
            this.$refs.refFolderComponent.setEdit(data)
            this.dialogFolder = true
        },
        showEditUpload(data) {
            this.$refs.refUploadComponent.setEdit(data)
            this.dialogUpload = true
        },
        showCreateFolder() {
            this.$refs.refFolderComponent.setAdd()
            this.dialogFolder = true
        },
        showUpload() {
            this.$refs.refUploadComponent.setParams(this.selectedFolderId, this.selectedUserId)
            this.dialogUpload = true
        },
        viewFiles(data) {
            if (this.selectedFolderId != data.folderId) {
                this.selectedFolderName = data.folderName
                this.selectedFolderColor = data.color
                this.selectedFolderId = data.folderId
                this.getUploadsByFolder()
            }
        },
        async getUploadsByFolder() {
            try{
                this.loading_files = true
                const response = await hr201Api.getUploads(this.selectedUserId, this.selectedFolderId)
                if (response && response.status == 200) {
                    this.files = response.data.items
                }
                this.loading_files = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async createFolderHandler(folderId) {
            await this.getFolders(false)
            if (folderId && this.folders.length) {
                const createdFolder = this.folders.filter(x => x.folderId == folderId)[0]
                this.viewFiles(createdFolder)
            }else{
                this.viewFiles(this.folders[0])
            }
        },
        async getFolders(show_loading) {
            try{
                this.loading_folders = show_loading
                const response = await hr201Api.getFolders()
                if (response && response.status == 200) {
                    this.folders = response.data.folders
                }
                this.loading_folders = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) {
                if (this.selectedFolderId) {
                    this.getUploadsByFolder()
                }
            }

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: this.selectedUserName,
            avatarPath: awsS3Helper.getProfileAvatarUrl(this.$route.params.userId)
        })

        await this.getFolders(true)

        if (this.folders.length) {
            this.viewFiles(this.folders[0])
        }
    },
    computed: {
        hasEditRights() {
            return accessPermissions.hasEditRights(this.$router.currentRoute.path)
        },
        selectedUserId() {
            return this.$route.params.userId
        },
        pageQueryId() {
            return `hr201-${this.selectedUserId}`
        },
        isMobile() {
            return window.innerWidth < 600
        },
        commentsData() {
            return { pageQueryId: this.pageQueryId }
        },
        isActiveAccount() {
            return !this.$store.state.selectedTwoZeroOneUser.deactivated
        },
        selectedUserName() {
            return `${this.$store.state.selectedTwoZeroOneUser.firstName} ${this.$store.state.selectedTwoZeroOneUser.lastName}`
        }
    },
}
</script>
<style scoped>
.files-header {
    margin-bottom:10px;
}
.menu-link {
  cursor: pointer;
}
.menu-link:hover {
  text-decoration: underline;
}
.menu-link-selected {
  cursor: pointer;
  font-weight: bold;
}
.menu-link-selected:hover {
  text-decoration: underline;
}
.menu-edit {
  display: none; /* hide by default */
  margin-right: -5px;
}
.v-chip:hover .menu-edit {
  display: inline-flex; /* show on hover */
}
.menu-container {
    padding:8px;
}
.file-card {
    border-radius:5px;
    height:auto;
}
.upload-edit {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s ease;
    margin-left: -8px;
}
tr:hover .upload-edit {
  visibility: visible;
  opacity: 1;
}
.downloadable-link:hover {
    text-decoration: underline;
    cursor: pointer;
}
.clickable {
    cursor: pointer;
}
.user-profile {
    cursor: pointer;
}
.user-profile:hover {
    text-decoration: underline;
}
</style>
